module.exports = __webpack_public_path__ + "assets/6fc41a4dcbb3206f1cbefa39091dccdb.jpg";